import Wix from 'Wix';
import axios from 'axios'
import httpRequest from "../widget/api/httpRequests"


const SetStyleParamsMigration = (oldSettings) => {
  Wix.Styles.getStyleParams(style => {
    if (Object.keys(style.numbers).length == 0) {  
    Wix.Styles.setNumberParam('borderWidth', {value: "20"});
    Wix.Styles.setNumberParam('cornerRadius', {value: oldSettings.cornerRadiusTopRight});
    }
});
}

const setDataPublic = (datapublicObj={}) => (dispatch) => {
  
    let compId = Wix.Utils.getOrigCompId();
    let dataPublic;

    //Disconnect account
    if (datapublicObj.disconnect == true) {
          Wix.Data.Public.set(compId, {
          ...datapublicObj,
          }, { scope: 'COMPONENT' },
            function onSuccess(data) {
              dataPublic = data[compId];
              window.localStorage.removeItem('token');
              dispatch({
                type: 'SET_DATA_PUBLIC',
                payload: dataPublic
              })
            });
        return;
    }

    axios.get("/api/getUserDataDrive" + httpRequest.getUrlQuery()).then( res => {
      let data = JSON.parse(res.data);
      dataPublic = {...data, ...datapublicObj};
      dataPublic.compId = compId;
      dataPublic.token = data.access_token;
      dataPublic.scope = data.scope;
      if (data.access_token !=="") {
        window.localStorage.setItem('token', JSON.stringify(data.access_token));
      }
      else {
        window.localStorage.removeItem('token');
      }
      delete dataPublic['access_token'];
      delete dataPublic['token'];
      delete dataPublic['id_token'];
      if(data.oldSettings){ //MIGRATION TO CHECK
        SetStyleParamsMigration(data.oldSettings);
      }
        Wix.Data.Public.set(compId, {
          ...dataPublic,
        }, { scope: 'COMPONENT' },
  
          function onSuccess(data) {
            dispatch({
              type: 'SET_DATA_PUBLIC',
              payload: data[compId]
            })
          },
          function onFailed(error) {
            console.log("setDataPublic datapublid",error)
          }
        );

    })
    .catch(res => {
      console.log("setDataPublic datapublid catch");
      //window.localStorage.removeItem('token');
      Wix.Data.Public.set(compId, {
        ...datapublicObj,
        "createdAt": new Date()
      }, { scope: 'COMPONENT' },
        function onSuccess(data) {
          console.log("setDataPublic datapublid catch success");
          dataPublic = data[compId];
          dispatch({
            type: 'SET_DATA_PUBLIC',
            payload: dataPublic
          })
        });
    })
}
export default setDataPublic;



// WEBPACK FOOTER //
// ./src/actions/dataPublicActions.js